/**
 * Rebuy dynamic-bundle: merge each product image into its own product block.
 *
 * Rebuy renders the widget as two flat sibling rows — every image in
 * .rebuy-bundle__images, every title/price in .rebuy-bundle__items. The two
 * rows wrap independently, so with 3+ products an image lands on a different
 * line than the title it belongs to.
 *
 * Moving the image node inside its matching .rebuy-product-block makes each
 * product a single flex item, so image + title + price wrap together.
 *
 * Rebuy re-renders the widget on variant/option changes and mounts it async,
 * so a MutationObserver re-runs the merge on every fresh render.
 */
(function () {
  'use strict';

  var MERGED = 'data-knesko-merged';

  function mergeBundle(bundle) {
    if (bundle.hasAttribute(MERGED)) return;

    var imagesRow = bundle.querySelector('.rebuy-bundle__images');
    var itemsRow = bundle.querySelector('.rebuy-bundle__items');
    if (!imagesRow || !itemsRow) return;

    var images = imagesRow.querySelectorAll('.rebuy-bundle__image');
    var blocks = itemsRow.querySelectorAll('.rebuy-product-block');

    // Bail while the two rows disagree — the widget is still rendering.
    if (!images.length || images.length !== blocks.length) return;

    for (var i = 0; i < images.length; i++) {
      blocks[i].insertBefore(images[i], blocks[i].firstChild);
    }

    // Hides the now-empty image row (it still holds Rebuy's divider nodes, so
    // :empty won't match). Also marks the bundle so we don't re-merge it.
    bundle.setAttribute(MERGED, '');
  }

  function mergeAll(widget) {
    var bundles = widget.querySelectorAll('.rebuy-bundle');
    for (var i = 0; i < bundles.length; i++) {
      mergeBundle(bundles[i]);
    }
  }

  function watch(widget) {
    var queued = false;

    var run = function () {
      queued = false;
      observer.disconnect();
      mergeAll(widget);
      observer.observe(widget, { childList: true, subtree: true });
    };

    // Disconnected while merging so our own DOM writes don't re-trigger it.
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(run);
    });

    run();
  }

  function init() {
    var widgets = document.querySelectorAll('.rebuy-bundle-widget');
    for (var i = 0; i < widgets.length; i++) {
      watch(widgets[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
